module.exports = __webpack_public_path__ + "static/media/testimonialsvisual.0d17d7ff.png";